import Home from './Home/Home';
import './App.css';
import AboutPage from './AboutPage/AboutPage';
import ProjectPage from './ProjectPage/ProjectPage';
import ContactUs from './ContactUs/ContactUs';
import Header from './Header/Header';
import { Route } from 'react-router-dom';

function App() {
  return (
    <div className="App">
      <Route path='/contact-us' component={ContactUs} exact />
      <Route path='/projects' component={ProjectPage} exact />
      <Route path='/about' component={AboutPage} exact />
      <Route path='/' component={Home} exact />
    </div>
  );
}

export default App;
